import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { DefaultPageComp } from "../../components/defaultPage"
import { TournamentComponent } from "../../components/tournament"

export const TournamentPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <TournamentComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}